// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Register.module.css */

.container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, var(--muted), var(--background));
  padding: 24px 12px; /* reduced padding to shorten page */
  font-family: 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.registerGrid {
  display: grid;
  grid-template-columns: 380px 1fr; /* slightly smaller promo column */
  gap: 24px;
  width: 100%;
  max-width: 1050px;
}

/* Promo panel */
.promo {
  background: linear-gradient(180deg, rgba(var(--primary-rgb), 0.06), rgba(var(--secondary-rgb), 0.04));
  border-radius: 14px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.promoInner {
  text-align: left;
}
.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}
.logoBox {
  width: 52px;
  height: 52px;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--background);
}
.brandTitle {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--foreground);
}
.promoTitle {
  font-size: 1.05rem;
  font-weight: 700;
  margin: 0 0 6px 0;
  color: var(--foreground);
}
.promoText {
  color: var(--muted-foreground);
  margin-bottom: 12px;
}
.promoImage {
  width: 100%;
  border-radius: 8px;
  margin-top: 10px;
  object-fit: cover;
  max-height: 160px; /* keep image compact */
}

/* Form */
.form {
  width: 100%;
  max-width: 720px;
  background: var(--background);
  padding: 20px; /* reduced padding */
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(17,24,39,0.06);
}

.formHeader {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.logoBoxSmall {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--background);
}
.title {
  margin: 0;
  color: var(--foreground);
  font-size: 1.25rem; /* slightly smaller to match Home scaling */
}
.subtitle {
  margin: 0;
  color: var(--muted-foreground);
  font-size: 0.9375rem; /* normalized to match Login/Home */
}

.error {
  color: var(--danger, #c0392b);
  margin-bottom: 12px;
  background: rgba(192,57,43,0.06);
  padding: 8px 10px;
  border-radius: 8px;
}

.success {
  color: var(--success);
  margin-bottom: 12px;
  background: rgba(var(--success-rgb), 0.06);
  padding: 8px 10px;
  border-radius: 8px;
}

.label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: var(--muted-foreground);
}

.input, .select {
  width: 100%;
  padding: 10px 12px; /* slightly smaller inputs */
  margin-bottom: 10px;
  border-radius: 8px;
  border: 1px solid var(--border);
  box-sizing: border-box;
  background: transparent;
  color: var(--foreground);
}

.input:focus, .select:focus {
  outline: none;
  box-shadow: 0 0 0 4px rgba(var(--primary-rgb), 0.06);
  border-color: var(--primary);
}

.consentSection {
  margin-top: 8px;
  margin-bottom: 12px;
}

.consentLabel {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 14px;
  color: var(--muted-foreground);
}

.checkbox {
  margin-top: 4px;
  width: 18px;
  height: 18px;
}

.termsLink {
  color: var(--primary);
  text-decoration: none;
}

.submitButton {
  width: 100%;
  padding: 12px;
  background: linear-gradient(90deg, var(--primary), var(--secondary));
  color: var(--background);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 700;
  font-size: 16px;
  text-decoration: none;
}

.submitButton:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.loginLink {
  text-align: center;
  margin-top: 14px;
  font-size: 14px;
  color: var(--muted-foreground);
}

.loginLink a {
  color: var(--primary);
  text-decoration: none;
}

/* Responsive */
@media (max-width: 900px) {
  .registerGrid {
    grid-template-columns: 1fr;
  }
  .promo { display: none; }
}

/* Compact form grid to reduce vertical length */
.formGrid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}
@media (min-width: 720px) {
  .formGrid { grid-template-columns: repeat(2, 1fr); gap: 12px; }
  /* span full width for consent and submit */
  .formGrid .full { grid-column: 1 / -1; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Register.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oEAAoE;EACpE,kBAAkB,EAAE,oCAAoC;EACxD,gCAAgC;EAChC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,gCAAgC,EAAE,kCAAkC;EACpE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,qGAAqG;EACrG,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qEAAqE;EACrE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB,EAAE,uBAAuB;AAC5C;;AAEA,SAAS;AACT;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa,EAAE,oBAAoB;EACnC,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qEAAqE;EACrE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB,EAAE,2CAA2C;AACjE;AACA;EACE,SAAS;EACT,8BAA8B;EAC9B,oBAAoB,EAAE,mCAAmC;AAC3D;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB,EAAE,4BAA4B;EAChD,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oEAAoE;EACpE,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;EACA,SAAS,aAAa,EAAE;AAC1B;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE,YAAY,qCAAqC,EAAE,SAAS,EAAE;EAC9D,2CAA2C;EAC3C,kBAAkB,mBAAmB,EAAE;AACzC","sourcesContent":["/* Register.module.css */\n\n.container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(180deg, var(--muted), var(--background));\n  padding: 24px 12px; /* reduced padding to shorten page */\n  font-family: 'Inter', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.registerGrid {\n  display: grid;\n  grid-template-columns: 380px 1fr; /* slightly smaller promo column */\n  gap: 24px;\n  width: 100%;\n  max-width: 1050px;\n}\n\n/* Promo panel */\n.promo {\n  background: linear-gradient(180deg, rgba(var(--primary-rgb), 0.06), rgba(var(--secondary-rgb), 0.04));\n  border-radius: 14px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.promoInner {\n  text-align: left;\n}\n.brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n.logoBox {\n  width: 52px;\n  height: 52px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, var(--primary), var(--secondary));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--background);\n}\n.brandTitle {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--foreground);\n}\n.promoTitle {\n  font-size: 1.05rem;\n  font-weight: 700;\n  margin: 0 0 6px 0;\n  color: var(--foreground);\n}\n.promoText {\n  color: var(--muted-foreground);\n  margin-bottom: 12px;\n}\n.promoImage {\n  width: 100%;\n  border-radius: 8px;\n  margin-top: 10px;\n  object-fit: cover;\n  max-height: 160px; /* keep image compact */\n}\n\n/* Form */\n.form {\n  width: 100%;\n  max-width: 720px;\n  background: var(--background);\n  padding: 20px; /* reduced padding */\n  border-radius: 12px;\n  box-shadow: 0 8px 30px rgba(17,24,39,0.06);\n}\n\n.formHeader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n.logoBoxSmall {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, var(--primary), var(--secondary));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--background);\n}\n.title {\n  margin: 0;\n  color: var(--foreground);\n  font-size: 1.25rem; /* slightly smaller to match Home scaling */\n}\n.subtitle {\n  margin: 0;\n  color: var(--muted-foreground);\n  font-size: 0.9375rem; /* normalized to match Login/Home */\n}\n\n.error {\n  color: var(--danger, #c0392b);\n  margin-bottom: 12px;\n  background: rgba(192,57,43,0.06);\n  padding: 8px 10px;\n  border-radius: 8px;\n}\n\n.success {\n  color: var(--success);\n  margin-bottom: 12px;\n  background: rgba(var(--success-rgb), 0.06);\n  padding: 8px 10px;\n  border-radius: 8px;\n}\n\n.label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 14px;\n  color: var(--muted-foreground);\n}\n\n.input, .select {\n  width: 100%;\n  padding: 10px 12px; /* slightly smaller inputs */\n  margin-bottom: 10px;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  box-sizing: border-box;\n  background: transparent;\n  color: var(--foreground);\n}\n\n.input:focus, .select:focus {\n  outline: none;\n  box-shadow: 0 0 0 4px rgba(var(--primary-rgb), 0.06);\n  border-color: var(--primary);\n}\n\n.consentSection {\n  margin-top: 8px;\n  margin-bottom: 12px;\n}\n\n.consentLabel {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 14px;\n  color: var(--muted-foreground);\n}\n\n.checkbox {\n  margin-top: 4px;\n  width: 18px;\n  height: 18px;\n}\n\n.termsLink {\n  color: var(--primary);\n  text-decoration: none;\n}\n\n.submitButton {\n  width: 100%;\n  padding: 12px;\n  background: linear-gradient(90deg, var(--primary), var(--secondary));\n  color: var(--background);\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  font-weight: 700;\n  font-size: 16px;\n  text-decoration: none;\n}\n\n.submitButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.loginLink {\n  text-align: center;\n  margin-top: 14px;\n  font-size: 14px;\n  color: var(--muted-foreground);\n}\n\n.loginLink a {\n  color: var(--primary);\n  text-decoration: none;\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n  .registerGrid {\n    grid-template-columns: 1fr;\n  }\n  .promo { display: none; }\n}\n\n/* Compact form grid to reduce vertical length */\n.formGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n}\n@media (min-width: 720px) {\n  .formGrid { grid-template-columns: repeat(2, 1fr); gap: 12px; }\n  /* span full width for consent and submit */\n  .formGrid .full { grid-column: 1 / -1; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
